import { Select } from 'antd'
import { languageOptions } from '@/src/data'

interface LanguageFilterProps {
  selectedLanguage: string
  onChange: (value: string) => void
}

// Sort languages alphabetically
const SORTED_LANGUAGES = languageOptions.sort((a, b) =>
  a.label.localeCompare(b.label)
)

export const LanguageFilter: React.FC<LanguageFilterProps> = ({
  selectedLanguage,
  onChange,
}) => {
  return (
    <Select
      data-testid='language-select'
      showSearch
      placeholder='Select a language'
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      value={selectedLanguage || undefined}
      options={SORTED_LANGUAGES}
      onChange={onChange}
      className='w-full'
      allowClear
      getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
    />
  )
}
